/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, May 6th 2022, 1:52:56 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Button from "@mui/material/Button";

interface SkipStepButtonProps {
  handleNextStep: () => void;
}

export const SkipStepButton = ({ handleNextStep }: SkipStepButtonProps) => (
  <Button variant="text" className="cta-style-A" size="large" color="primary" onClick={handleNextStep}>
    Skip this
  </Button>
);
